<template>
	<v-toolbar class="chat-header" elevation="0">
		<v-img :src="bot_image" class="bot-toolbar-image" />
		<v-toolbar-title>
			<div class="d-flex flex-column align-start">
				<span class="bot-name">{{ bot_name }}</span>
				<Typing :loading="loading" />
			</div>
		</v-toolbar-title>
		<v-spacer></v-spacer>
		<v-toolbar-items>
			<v-tooltip bottom v-if="bot_phone != null">
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						dark
						tag="a"
						id="waicon"
						v-bind="attrs"
						v-on="on"
						:href="whatsapp_link"
						target="_blank"
					>
						<v-icon size="30">mdi-whatsapp</v-icon>
					</v-btn>
				</template>
				<span>Whatsapp</span>
			</v-tooltip>
			<v-tooltip bottom v-if="bot_phone != null">
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						dark
						tag="a"
						v-bind="attrs"
						v-on="on"
						:href="`tel:${bot_phone}`"
					>
						<v-icon size="30">mdi-phone</v-icon>
					</v-btn>
				</template>
				<span>Llamar</span>
			</v-tooltip>
		</v-toolbar-items>
	</v-toolbar>
</template>
<script>
import Typing from "../Messages/TypingLoader";

export default {
	components: {
		Typing,
	},
	data: () => ({
		// items: [
		//     { title: 'Opcion 1'},
		//     { title: 'Opcion 2'},
		//     { title: 'Opcion 3'},
		// ]
	}),
	computed: {
		loading() {
			return this.$store.getters["chatStore/get_request"];
		},
		bot_name: function() {
			return this.$store.getters["chatStore/get_structure"].name;
		},
		bot_image: function() {
			return this.$store.getters["chatStore/get_structure"].image.url;
		},
		bot_phone: function() {
			return this.$store.getters["chatStore/get_structure"].phone;
		},
		whatsapp: function() {
			let whatsapp = this.$store.getters["chatStore/get_structure"].phone;
			return whatsapp.replace(/[+|_|-]/g, "");
		},
		finalCart: function() {
			return this.$store.getters["chatStore/get_bill"];
		},
		whatsapp_message: function() {
			// mensaje a whatsapp
			let str = "";
			let { products, extras } = this.$store.getters["chatStore/get_cart"];
			let cartLength = 0;
			if (products) cartLength += products.length;
			if (extras) cartLength += extras.length;

			switch (cartLength) {
				case 0:
					str = `Hola ${this.bot_name}!\nTe escribo desde tu tienda online y estoy interesado en tus productos`;
					break;
				default: {
					let total = 0;

					let bill = this.$store.getters["chatStore/get_bank"];
					str = "Hola!👋, deseo comprar: \n\n";
					this.$store.getters["chatStore/get_cart"].products.map((item) => {
						total += parseFloat(Number(item.price)) * item.qtt;

						str += `--${item.qtt !== 1 ? "[" + item.qtt + "]" : ""} *${
							item.name
						}* > $${item.price}\n`;

						if (item.observation) {
							str += `observacion: ${item.observation}\n\n`;
						}
					});

					if (bill.bank_name) {
						/**
						 * Mediantes BANESCO
						 */
						str += `Mediante ${bill.bank_name}\n`;
					}

					str += `\n---------------------------\n`;
					str += `Para un total de $${total}`;

					break;
				}
			}

			if (
				(this.finalCart.products && this.finalCart.products.length > 0) ||
				(this.finalCart.extras && this.finalCart.extras.length > 0)
			) {
				let total = 0;
				let purchaseBill = this.$store.getters["chatStore/getPurchaseBill"];
				let bill = this.$store.getters["chatStore/get_bank"];
				let deliveryData = this.$store.getters["chatStore/get_delivery_data"];

				str = `Hola!👋, acabo de hacer una compra\n`;
				str += `Pedido: ${purchaseBill.code.slice(-5)}\n`;
				this.finalCart.products.map((item) => {
					total += parseFloat(Number(item.price)) * item.qtt;

					str += `--${item.qtt !== 1 ? "[" + item.qtt + "]" : ""} *${
						item.name
					}* > $${item.price}\n`;

					if (item.observation) {
						str += `observacion: ${item.observation}\n`;
					}
				});
				this.finalCart.extras.map((item) => {
					total += parseFloat(Number(item.price)) * item.qtt;

					str += `--${item.qtt !== 1 ? "[" + item.qtt + "]" : ""} *${
						item.name
					}* > $${item.price}\n`;

					if (item.observation) {
						str += `observacion: ${item.observation}\n`;
					}
				});

				str += `\n---------------------------\n`;
				if (deliveryData.delivery) {
					total += Number(deliveryData.price, 10);
					str += `Con delivery de $${deliveryData.price}\n`;
					if (deliveryData.delivery_id) {
						str += `mediante ${
							deliveryData.companies.filter(
								(c) => c.id === deliveryData.delivery_id
							)[0].name
						}\n`;
					}
				}

				let { name, lastname, phone, city } = this.$store.getters[
					"chatStore/get_user"
				];

				str += `*Total: $${total}* \n`;
				if (bill.account_type == "VES") {
					str += `*Total: ${new Intl.NumberFormat("es-VE", {
						style: "currency",
						currency: "VES",
					}).format(total * purchaseBill.dollar_price)}* \n`;
				}
				str += `Nombre: ${name} ${lastname}\n`;
				str += `Teléfono: ${phone}\n`;
				str += `Ciudad: ${city}\n`;
				if (bill.bank_name) {
					/**
					 * Mediantes BANESCO
					 */
					str += `Forma de Pago: ${bill.bank_name}\n`;
				}

				str += `Comprobante: https://api.tubotones.com/voucher/${purchaseBill.code}\n`;
				// str += `Factura: https://api.tubotones.com/invoice/${purchaseBill.code}\n`;
			}

			return encodeURIComponent(str);
		},
		whatsapp_link: function() {
			return `https://wa.me/${this.whatsapp}?text=${this.whatsapp_message}`;
		},
	},
	created() {
		const data = {
			id: this.$route.params.id,
			product: this.$route.params.product,
		};
		this.$store.dispatch("chatStore/init", data);
	},
};
</script>
<style lang="scss">
.bot-toolbar-image {
	max-width: 45px;
	width: 45px;
	height: 45px;
	.v-image__image {
		max-width: 45px !important;
		width: 45px !important;
		height: 45px !important;
	}
	display: inline-block;
	border-radius: 50%;
	margin-right: 10px;
	border: 1px solid var(--secondary-color);
	background-color: var(--secondary-color);
	background-image: url("../../assets/user.svg");
	background-position: cover;
}
.bot-name {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: block;
	width: 100%;
	font-size: 20px;
	font-family: "Lato";
	font-weight: 700;
}
.chat-header {
	box-shadow: none !important;
	height: 61px;
	background-color: var(--primary-color) !important;
	color: var(--secondary-color) !important;
	* {
		color: var(--secondary-color) !important;
		box-shadow: none !important;
	}
}
</style>
